exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-pagination .dropdown{margin-bottom:0}.footer-pagination .page-options{margin-left:20px}.footer-pagination .page-info{margin-left:50px}.footer-pagination a.btn-next,.footer-pagination a.btn-prev{margin-left:30px!important}@media screen and (max-width:480px){.footer-pagination,.footer-pagination label{font-size:14px}.footer-pagination .page-options{margin-left:10px}.footer-pagination .page-info{margin-left:15px}.footer-pagination a.btn-next,.footer-pagination a.btn-prev{margin-left:15px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"37","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/vkb-data-table.vue
// module id = lNx1
// module chunks = 0